type Bucket = {
  bucketKey: string,
  sortOrder: number,
}

export interface SimpleSignboard {
  signboardId: number | null
  signupKey: string
  signupName: string
  note: string
  bucketList: Bucket[]
}

export class SimpleSignboardDTO implements SimpleSignboard {
  signboardId: number | null;
  signupKey: string;
  signupName: string;
  note: string;
  bucketList: Bucket[];

  constructor(
    signboardId: number | null,
    signupKey: string,
    signupName: string,
    note: string,
    bucketList: Bucket[]
  ) {
    this.signboardId = signboardId;
    this.signupKey = signupKey;
    this.signupName = signupName;
    this.note = note;
    this.bucketList = bucketList;
  }

  static fromJSON(jsonObject: SimpleSignboard): SimpleSignboardDTO {
    return new SimpleSignboardDTO(
      jsonObject.signboardId,
      jsonObject.signupKey,
      jsonObject.signupName,
      jsonObject.note,
      jsonObject.bucketList,
    )
  }
}
